import { devLog } from '@atlassian/help-center-common-util/dev-logger';

export interface SSRInput {
    initialHtml: string;
    cookiesConsentToken?: string;
    cookiesFallbackToken?: string;
    cookiesShowBannerToken?: string;
}

export const getSSRInput = (): SSRInput | undefined => {
    if (!__SERVER__) {
        return undefined;
    }
    if (!globalThis?.SSR_input || typeof globalThis?.SSR_input !== 'string') {
        return undefined;
    }
    try {
        const parsedSSRInput = JSON.parse(globalThis.SSR_input) as SSRInput;
        return {
            initialHtml: parsedSSRInput.initialHtml,
            cookiesConsentToken: parsedSSRInput.cookiesConsentToken,
            cookiesFallbackToken: parsedSSRInput.cookiesFallbackToken,
            cookiesShowBannerToken: parsedSSRInput.cookiesShowBannerToken,
        };
    } catch (error) {
        devLog('Error parsing SSR input', error);
        return undefined;
    }
};
